import React from "react";
import EditorSidebar from "./EditorSidebar";

const EditorLayout = ({ children }) => {
  return (
    <div className="d-flex" style={{ minHeight: "100vh" }}>
      <EditorSidebar />
      <div className="flex-grow-1 p-4 bg-white">{children}</div>
    </div>
  );
};

export default EditorLayout;
